import { Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

const TicketsTable = ({ projectData }) => {
  const tickets = projectData.tickets || [];
  // room, window,product,fabric,status
  const columns = [
    { field: "bag", headerName: "Bag", width: 75},
    { field: "room", headerName: "Room", width: 150 },
    { field: "window", headerName: "Window", width: 150 },
    { field: "product", headerName: "Product", width: 200 },
    { field: "fabric", headerName: "Fabric", width: 250 },
    { field: "status", headerName: "Status", width: 150 },
  ];
  const inMaking = [
    "Hemmed",
    "Tape Attached",
    "Drop Measured",
    "Lining Attached",
    "Pleated",
    "Hooks & Final QC",
  ];
  const availableStatus = [
    "Ticket Created",
    "Awaiting Replacement",
    "Cut",
    "Packed",
    "Collected",
  ];
  const mapStatus = (status) => {
    if (inMaking.includes(status)) {
      return "In Making";
    } else if (availableStatus.includes(status)) {
      return status;
    } else {
      return "-";
    }
  };
  const rows = tickets.map((ticket, index) => ({
    id: index,
    bag: ticket?.bag,
    room: ticket.room,
    window: ticket.window,
    product: ticket.product,
    fabric: ticket.fabric,
    status: mapStatus(ticket?.status),
  }));

  return (
    <div style={{ width: "100%", margin: "2rem" }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Items
      </Typography>
      <DataGrid rows={rows} columns={columns} hideFooter />
    </div>
  );
};

export default TicketsTable;
